<template>
  <div class="carousel bg-white">
    <vue-slick-carousel
      v-bind="settings"
      class="carousel-slick"
      @beforeChange="beforeChange"
    >
      <img
        class="carousel-image"
        v-for="slide in slides"
        :key="slide.id"
        :srcset="`${slide.imageList.preview} 482w,
          ${slide.imageList.provided} 1031w`"
        sizes="(max-width: 482px) 482px,
          1031px"
        :src="slide.imageList.preview"
        :alt="slide.name"
        :title="`Weitere Infos zu: ${slide.name}`"
        :data-slide-id="slide.id"
        @mousedown="onMouseDown"
        @click="onClick"
        @touchstart="onMouseDown"
        @touchend="onClick"
        role="img"
      >
    </vue-slick-carousel>

    <div
      id="distance-container"
      class="p-2 d-flex justify-content-center"
      :class="userPosition ? 'text-white' : 'no-gps'"
      @click="showGpsModal"
    >
      <icon-base
        :title="$t('common.distance')"
        :alt="$t('common.distance')"
        width="17"
        height="17"
        class="mr-1"
        role="img"
      >
        <icon-distance />
      </icon-base>
      <span v-if="userPosition">{{ $t("common.~") }}{{ currentSlide.distanceText }}</span>
      <span v-else>{{ $t("dashboard.gpsDisabled") }}</span>
    </div>

    <b-container fluid class="pt-2 pb-3 text-center">
      <router-link
        :to="`/${$route.params.locale}/institutions/dashboard/details/${currentSlide.id}`"
        id="slider-title"
      >
        {{ currentSlide.name }}
      </router-link>
    </b-container>
  </div>
</template>

<script>
import { shuffle } from 'lodash'
import { mapGetters } from 'vuex'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'Carousel',
  components: {
    'vue-slick-carousel': VueSlickCarousel
  },
  data() {
    return {
      curSlide: 0,
      settings: {
        'dots': false,
        'infinite': true,
        'centerMode': true,
        'adaptiveHeight': false,
        'slidesToScroll': 1,
        'slidesToShow': 1,
        'arrows': true,
        'focusOnSelect': true,
        'focusOnChange': true,
        'mobileFirst': true,
        'centerPadding': '250px',
        'responsive': [
          {
            'breakpoint': 991, // below LG screens
            'settings': {
              'centerPadding': '150px',
              'slidesToShow': 1
            }
          },
          {
            'breakpoint': 767, // below MD screens
            'settings': {
              'centerPadding': '50px',
              'slidesToShow': 1
            }
          }
        ]

      },
      numSlides: 5
    }
  },
  props: {
    'institutions': {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      userPosition: 'userPosition/getPosition'
    }),
    slides() {
      return (this.userPosition)
        ? this.institutions.slice(0, this.numSlides)
        : shuffle(this.institutions).slice(0, this.numSlides)
    },
    currentSlide() {
      return this.slides[this.curSlide]
    }
  },
  methods: {
    beforeChange(oldSlide, newSlide) {
      this.curSlide = newSlide
    },
    onClick(event) {
      const pageX = event.pageX || event.changedTouches[0].pageX
      const offset = this.lastScreenX - pageX

      if (offset > -10 && offset < 10) {
        this.$router.push(`/${this.$route.params.locale}/institutions/dashboard/details/${event.target.dataset.slideId}`)
      } else {
        event.preventDefault()
      }
    },
    onMouseDown(event) {
      const pageX = event.pageX || event.touches[0].pageX
      this.lastScreenX = pageX
    },
    showGpsModal(event) {
      if (!this.userPosition) this.$bvModal.show('no-gps-modal')
      else this.$router.push(`/${this.$route.params.locale}/institutions/dashboard/details/${this.currentSlide.id}`)
    }
  }
}
</script>

<style lang="scss">
// TODO: NEEDS TO BE ADJUSTED WHEN MERGED WITH HIGH RES IMAGES
.carousel-image {
  max-height: 350px;
  padding: 0 2px;
  height: 100%;
  border-radius: 0.75rem;
  object-fit: cover;
  cursor: pointer;
}
.slick-prev {
  height: 100%;
  left: 0px !important;
  padding: 0px 48px 0px 15px;
  z-index: 1000;
}
.slick-next {
  height: 100%;
  right: 0px !important;
  padding: 0px 35px 0px 48px;
  z-index: 1000;
}
.slick-prev:before {
  color: #fff;
}
.slick-next:before {
  color: #fff;
}
.carousel-main div img {
  height: 100%;
  object-fit: cover;
}
#slider-title{
  font-size: 15px;
  font-weight: 500;
}
#distance-container {
  border-radius: 0rem 0rem 0.75rem 0.75rem;
  background-color: var(--primary);
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: -0.21px;
  position: absolute;
  top: 0px;
  left: 60px;
  cursor: pointer;
}
.no-gps {
  color: $warning !important;
}
.no-gps:hover,
.no-gps:active {
  color: $warning-light !important;
}
@media (min-width: $breakpoint-md) {
  #distance-container {
    left: 160px;
  }
  .slick-prev {
    padding: 0px 86px 0px 63px;
  }
  .slick-next {
    padding: 0px 80px 0px 68px;
  }
}

@media (min-width: $breakpoint-lg) {
  #distance-container {
    left: 260px;
  }
  .slick-prev {
    padding: 0px 22px 0px 60px;
  }
  .slick-next {
    padding: 0 80px 0 0;
  }
}
</style>
